import moment from 'moment';
import React, { Fragment, useState, useEffect, memo } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import pdfClincHistory from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfHistory';
import pdfEvent from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfEvent';
import PDFTranscription from '../../../../AudioPanel/PDFTranscription';

import {
    validateProcessECO, validateProcessEstres, validateProcessPrueba, validateProcessEKG,
    validateProcessHolter, validateProcessMapa
} from '../../../../Utils/UtilOtherProcedures';
import DataReactTableCHPatient from './DataReactTableCHPatient';
import { calculateAgeParse } from '../../../../Utils/Patient';
import { style } from 'wavesurfer.js/src/util';

const PatientClinicHistory = ({ id_patient = '0', clinicHistoryByPatient }) => {
    //const [clinicHistoryByPatient, setClinicHistoryByPatient] = useState(null);
    const [loadTable, setLoadTable] = useState(false);
    const [patient, setPatient] = useState(null);
    const [showPDFClinicHistoryComplete, setShowPDFClinicHistoryComplete] = useState(false);
    const [eventByAdmission, setEventByAdmission] = useState(null);
    const [infoAdmissionPatient, setInfoAdmissionPatient] = useState(null);
    const [third, setThird] = useState(null);
    const [showPDFClinicEvent, setShowPDFClinicEvent] = useState(false);
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));


    useEffect(() => {
        const loadSearchPatient = async () => {
            let dataSend = {
                num_documento: parseInt(id_patient)
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        //setPatient(data.contenido[0])
                        //loadClinicHistory(data.contenido[0].id_historia)
                        setPatient(data.contenido[0]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        const loadClinicHistory = async (id_historia) => {
            setLoadTable(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("HIST", data);
                    setLoadTable(false);
                    //setClinicHistoryByPatient(data);
                    filterClinicHistoriesFromEmpty(data.admisiones);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        if (id_patient !== null && id_patient !== undefined) {
            loadSearchPatient();
        }
    }, [])

    //Filtra las historias clinicas que se han llenado de las que no
    const filterClinicHistoriesFromEmpty = async (wholeClinicHistories) => {
        let clinicHistoryToShow = [];
        for (let i = 0; i < wholeClinicHistories.length; i++) {
            console.log(wholeClinicHistories[i]);
            if (wholeClinicHistories[i].hasOwnProperty("anamnesis")) {
                if (wholeClinicHistories[i].hasOwnProperty("procedimientos")) {
                    let resultsPocedures = [];
                    if (wholeClinicHistories[i].procedimientos.eco.hasOwnProperty('eco') ||
                        wholeClinicHistories[i].procedimientos.estres.hasOwnProperty('estres') ||
                        wholeClinicHistories[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                        wholeClinicHistories[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                        wholeClinicHistories[i].procedimientos.holter.hasOwnProperty('holter') ||
                        wholeClinicHistories[i].procedimientos.mapa.hasOwnProperty('mapa')) {

                        let resultOtherProcedureEco = await validateProcessECO(wholeClinicHistories[i].procedimientos.eco.eco[0]) ? wholeClinicHistories[i].procedimientos.eco.eco[0].conclusiones : null;
                        let resultOtherProcedureEstres = await validateProcessEstres(wholeClinicHistories[i].procedimientos.estres.estres[0]) ? wholeClinicHistories[i].procedimientos.estres.estres[0].conclusiones : null;
                        let resultOtherProcedurePrueba = await validateProcessPrueba(wholeClinicHistories[i].procedimientos.prueba.prueba[0]) ? wholeClinicHistories[i].procedimientos.prueba.prueba[0].conclusiones : null;
                        let resultOtherProcedureEkg = await validateProcessEKG(wholeClinicHistories[i].procedimientos.ekg.ekg[0]) ?
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions :
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                    wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                        let resultOtherProcedureHolter = await validateProcessHolter(wholeClinicHistories[i].procedimientos.holter.holter[0]) ? wholeClinicHistories[i].procedimientos.holter.holter[0].conclusion : null;
                        let resultOtherProcedureMapa = await validateProcessMapa(wholeClinicHistories[i].procedimientos.mapa.mapa[0]) ? wholeClinicHistories[i].procedimientos.mapa.mapa[0].conclusion : null;

                        if (resultOtherProcedureEco !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEco });
                            }
                        }
                        if (resultOtherProcedureEstres !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEstres });
                            }
                        }
                        if (resultOtherProcedurePrueba !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedurePrueba });
                            }
                        }
                        if (resultOtherProcedureEkg !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEkg });
                            }
                        }
                        if (resultOtherProcedureHolter !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureHolter });
                            }
                        }
                        if (resultOtherProcedureMapa !== null) {
                            let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                            if (nameServ.length && typeof nameServ !== '[]') {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureMapa });
                            }
                        }
                    }
                    clinicHistoryToShow.push(wholeClinicHistories[i]);
                }
                //clinicHistoryToShow.push(wholeClinicHistories[i]);
            } else if (wholeClinicHistories[i].hasOwnProperty("procedimientos")) {
                let resultsPocedures = [];
                if (wholeClinicHistories[i].procedimientos.eco.hasOwnProperty('eco') ||
                    wholeClinicHistories[i].procedimientos.estres.hasOwnProperty('estres') ||
                    wholeClinicHistories[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                    wholeClinicHistories[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                    wholeClinicHistories[i].procedimientos.holter.hasOwnProperty('holter') ||
                    wholeClinicHistories[i].procedimientos.mapa.hasOwnProperty('mapa')) {

                    let resultOtherProcedureEco = await validateProcessECO(wholeClinicHistories[i].procedimientos.eco.eco[0]) ? wholeClinicHistories[i].procedimientos.eco.eco[0].conclusiones : null;
                    let resultOtherProcedureEstres = await validateProcessEstres(wholeClinicHistories[i].procedimientos.estres.estres[0]) ? wholeClinicHistories[i].procedimientos.estres.estres[0].conclusiones : null;
                    let resultOtherProcedurePrueba = await validateProcessPrueba(wholeClinicHistories[i].procedimientos.prueba.prueba[0]) ? wholeClinicHistories[i].procedimientos.prueba.prueba[0].conclusiones : null;
                    let resultOtherProcedureEkg = await validateProcessEKG(wholeClinicHistories[i].procedimientos.ekg.ekg[0]) ?
                        wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusions :
                            wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion !== null ? wholeClinicHistories[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                    let resultOtherProcedureHolter = await validateProcessHolter(wholeClinicHistories[i].procedimientos.holter.holter[0]) ? wholeClinicHistories[i].procedimientos.holter.holter[0].conclusion : null;
                    let resultOtherProcedureMapa = await validateProcessMapa(wholeClinicHistories[i].procedimientos.mapa.mapa[0]) ? wholeClinicHistories[i].procedimientos.mapa.mapa[0].conclusion : null;

                    if (resultOtherProcedureEco !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEco });
                        }
                    }
                    if (resultOtherProcedureEstres !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEstres });
                        }
                    }
                    if (resultOtherProcedurePrueba !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedurePrueba });
                        }
                    }
                    if (resultOtherProcedureEkg !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEkg });
                        }
                    }
                    if (resultOtherProcedureHolter !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureHolter });
                        }
                    }
                    if (resultOtherProcedureMapa !== null) {
                        let nameServ = wholeClinicHistories[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                        if (nameServ.length && typeof nameServ !== '[]') {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureMapa });
                        }
                    }
                    clinicHistoryToShow.push(wholeClinicHistories[i]);
                }

            } else if (wholeClinicHistories[i].transcripcion !== null && wholeClinicHistories[i].transcripcion !== undefined) {
                clinicHistoryToShow.push(wholeClinicHistories[i]);
            }
        }
        console.log("WHOLE", clinicHistoryToShow);
        //setClinicHistoryByPatient(clinicHistoryToShow);
    }

    const reactTableData = {
        tableHeaderData: [{
            Header: 'ADM',
            accessor: 'id_admision',
            disableGlobalFilter: true
        },
        {
            Header: 'FECHA',
            accessor: 'fecha',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        {
            Header: 'SERVICIO',
            Cell: row => (
                <label>{row.row.original.cita?.servicio != null && row.row.original.cita?.servicio != undefined ? row.row.original.cita?.servicio.servicios[0].nombre : ''}</label>
            )
        },
        {
            Header: 'PROFESIONAL',
            accessor: 'nombres',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? row.row.original.nombres + ' ' + row.row.original.apellido1 : null}</label>
            )
        },
        ],
        tableRowsData: clinicHistoryByPatient
    };

    const LoadInfo = () => {
        return (<DataReactTableCHPatient
            reactTableData={reactTableData}
            generateClinicEvent={generateClinicEvent}
        />)
    }

    const makePdfHistory = () => {
        var fullname = patient?.nombres + ' ' + patient?.apellido1 + ' ' + patient?.apellido2;
        const data = {
            today: new Date(),
            urlLogo: urlLogo,
            names: fullname,
            day: moment(new Date()).format('LL'),
            //ordenes: this.state.ordenes,
            admissions: clinicHistoryByPatient,
            gender: patient?.sexo,
            address: patient?.direccion.direccion,
            city: patient?.direccion.ciudad,
            telephone: patient?.telefono1,
            cellphone: patient?.celular,
            civilStatus: patient?.e_civil,
            bloodType: patient?.tipo_sangre,
            typeOfDocument: patient?.tip_documento,
            documentNumber: patient?.num_documento,
            profile: profile,
            age: calculateAgeParse(patient?.fec_nacimiento),
            birthday: patient?.fec_nacimiento,
            //id_admision: this.props.id_admision,
            //professional: this.state.professional,
            id_historia: parseInt(patient?.id_historia),
        };

        setShowPDFClinicHistoryComplete(true);
        pdfClincHistory(data, 'PDF', null);

    }

    const getPrintEvent = (id_historia, id_admision) => {
        return new Promise((resolve, reject) => {
            const dataSend = {
                id_historia: parseInt(id_historia),
                id_admision: parseInt(id_admision)
            }
            fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("evento/consultar", data);
                    setEventByAdmission(data.contenido);
                    resolve(data.contenido);
                })
                .catch((error) => {
                    alert(error);
                    resolve([]);
                    console.error('Error:', error);
                });
        })
    }


    const getListRadipharmacyDosse = (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-radiofarmaco/listar-por-admision?id_admision=' + id_admision, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(data => {
                if (data.length > 0) {
                    resolve(data);
                }
                else {
                    resolve([]);
                }
            }).catch((error) => {
                resolve([]);
                console.error('Error:', error);
            });
        })
    }

    const generateClinicEvent = async (historyEvent) => {
        console.log("DESActions", historyEvent);
        let clinicEvent = await getPrintEvent(patient?.id_historia, historyEvent.id_admision);
        console.log("DES", clinicEvent);
        let farmacos = await getListRadipharmacyDosse(historyEvent.id_admision);
        var fullname = patient?.nombres + ' ' + patient?.apellido1 + ' ' + patient?.apellido2;
        //infoAdmission.admision?.id_admision
        let infoAdmission = { admision: { id_admision: historyEvent.id_admision, fecha: historyEvent.fecha } }
        let nameProcedure = historyEvent.cita?.servicio?.servicios.length > 0 ? historyEvent.cita?.servicio?.servicios[0].nombre : '';
        let cupsProcedure = historyEvent.cita?.servicio?.servicios.length > 0 ? historyEvent.cita?.servicio?.servicios[0].codigo : '';

        /* if(historyEvent.transcripcion === null && historyEvent.anamnesis !== null && historyEvent.anamnesis !== undefined){
        } else if (historyEvent.transcripcion !== null){
            printTranscription(historyEvent.transcripcion );
        } */
        const data = {
            today: new Date(),
            urlLogo: urlLogo,
            names: fullname,
            day: new Date(),
            ordenes: clinicEvent?.ordenes,
            anamnesis: clinicEvent?.anamnesis,
            antecedentes: clinicEvent?.antecedentes,
            fisico: clinicEvent?.fisico,
            plan: clinicEvent?.plan,
            gender: patient?.sexo,
            address: patient?.direccion.direccion,
            city: patient?.direccion.ciudad,
            telephone: patient?.telefono1,
            cellphone: patient?.celular,
            civilStatus: patient?.e_civil,
            bloodType: patient?.tipo_sangre,
            typeOfDocument: patient?.tip_documento,
            documentNumber: patient?.num_documento,
            profile: profile,
            age: calculateAgeParse(patient?.fec_nacimiento),
            birthday: patient?.fec_nacimiento,
            professional: clinicEvent?.profesional,
            id_profesional: historyEvent?.id_profesional,
            speechTerapy: clinicEvent?.speechTerapy,
            radioPharmacy: clinicEvent?.radioPharmacy,
            medicalRegister: clinicEvent?.registro_clinico,
            diagnostico: clinicEvent?.diagnostico,
            notas_clinicas: clinicEvent?.notas_clinicas,
            radioPharmacyList: farmacos,
            sistemas: clinicEvent?.sistemas,
            third: third,
            infoAdmission: infoAdmission,
            transcripcion: historyEvent?.transcripcion,
            nameProcedure: nameProcedure,
            cupsProcedure: cupsProcedure,
            otherProcedures: clinicEvent?.procedimientos,
            cita: historyEvent?.cita
        };
        setShowPDFClinicEvent(true);
        await pdfEvent(data);

    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>HISTORIA CLÍNICA</b></h4>
                                </div>
                                <div className='tooltip-hc'>
                                    <Tooltip title="Historia Clínica Completa">
                                        <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb' }}
                                            disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                            onClick={() => {
                                                makePdfHistory();
                                            }}
                                        >
                                            <ListAltIcon style={{ color: '#153365' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    loadTable ?
                                        <div className="text-center">
                                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                        </div>
                                        : clinicHistoryByPatient &&
                                        <LoadInfo />

                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {showPDFClinicHistoryComplete ?
                <Modal
                    open={showPDFClinicHistoryComplete}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFClinicHistoryComplete(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
            {showPDFClinicEvent ?
                <Modal
                    open={showPDFClinicEvent}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFClinicEvent(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default memo(PatientClinicHistory)